import AlarmGroupReplaceFlow     	 from 'scripts/defa/alarm-groups/view-alarm-group-replace-flow';
import SubscriptionReplaceChoiceForm from 'scripts/defa/subscriptions/view-subscription-replace-choice-form.js';
import SubscriptionReplaceFlow   	 from 'scripts/defa/subscriptions/view-subscription-replace-flow';
import SubscriptionSettingsPanel 	 from 'scripts/defa/subscriptions/view-subscription-settings-panel';
import SubscriptionTerminateFlow 	 from 'scripts/defa/subscriptions/view-subscription-terminate-flow';
import SubscriptionTransferFlow  	 from 'scripts/defa/subscriptions/view-subscription-transfer-flow';
import Container                 	 from 'scripts/poppet/container';
import template                  	 from 'templates/subscriptionContainer.jst.html';

/**
 * defa.views.SubscriptionContainer
 * The base container for Subscriptions
 * @version 1.2.2
 */

const channel = Bb.Radio.channel( 'objects' );
const userChannel = Bb.Radio.channel( 'user' );


const selectors = {
	region: '[data-region=subscription-container]',
};

const SubscriptionContainer = Container.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.region,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches a designated view into the container region.
	 * @void
	 */
	attachView: function () {
		
		switch ( this.options.view ) {
			
			case 'subscription:panel' :
				this._showSettingsPanel();
				break;
			
			case 'subscription:terminate' :
				this._showTerminateView();
				break;
			
			case 'subscription:transfer' :
				this._showTransferView();
				break;
			
			case 'subscription:replace' :
				this._showReplaceFlow();
				break;
		}
	},
	
	// view functions
	
	/**
	 * Displays a subscription overview panel with terminate and transfer options.
	 * @void
	 */
	_showSettingsPanel: function () {
		
		let subscriptionSettingsPanel = new SubscriptionSettingsPanel( _.extend( this.options, {
			model: this.options.subscription,
		} ) );
		
		this.showChildView( 'container', subscriptionSettingsPanel );
	},
	
	/**
	 * Displays a subscription terminate view.
	 * @void
	 */
	_showTerminateView: function () {
		
		let subscriptionTerminateFlow = new SubscriptionTerminateFlow( _.extend( this.options, {
			model: this.options.subscription,
		} ) );
		
		this.showChildView( 'container', subscriptionTerminateFlow );
	},
	
	/**
	 * Displays a subscription transfer view.
	 * @void
	 */
	_showTransferView: function () {
		
		let subscriptionTransferFlow = new SubscriptionTransferFlow( _.extend( this.options, {
			model: this.options.subscription,
		} ) );
		
		this.showChildView( 'container', subscriptionTransferFlow );
	},
	
	/**
	 * Displays a subscription swap view.
	 * @void
	 */
	_showSwapSubscription: function(){
		let subscriptionReplaceFlow = new SubscriptionReplaceFlow( _.extend( this.options, {
			model: this.options.subscription,
		} ) );
		
		this.showChildView( 'container', subscriptionReplaceFlow );
	},
	
	/**
	 * Displays a subscription alarm replace view.
	 * @void
	 */
	_showAddAlarm: function(){
		let alarmGroupReplaceFlow = new AlarmGroupReplaceFlow( _.extend( this.options, {
			model: this.options.subscription,
		} ) );
		
		this.showChildView( 'container', alarmGroupReplaceFlow );
	},
	
	/**
	 * Displays a subscription swap view and removes the alarmgroup.
	 * @void
	 */
	_showRemoveAlarm: function(){
		let subscriptionReplaceFlow = new SubscriptionReplaceFlow( _.extend( this.options, {
			model       : this.options.subscription,
			noAlarmGroup: true,
		} ) );
		
		this.showChildView( 'container', subscriptionReplaceFlow );
	},
	
	/**
	 * Displays a subscription replace flow.
	 * @void
	 */
	_showReplaceFlow: function() {
		// !Update oct 2018 - there are now 3 flows for replacement and one choice view.
		// display a choise of options, based on roles and current subscription details.
		
		let isTechSupport = userChannel.request( 'is:techsupport' );
		let	hasAlarmGroup = channel.request( 'units' ).get( this.options.subscription.get( 'unit' ) ).get( 'transientAlarmCentral' );
		
		let subscriptionReplaceChoiceForm = new SubscriptionReplaceChoiceForm({
			isTechSupport: isTechSupport,
			hasAlarmGroup: hasAlarmGroup,
		});
		
		this.listenToOnce( subscriptionReplaceChoiceForm, 'replace:choice', function( result ) {
			switch ( result ) {
				
				// just swap the subscription.
				case 'swap:subscription' :
					this._showSwapSubscription();
					break;
				
				
				// add (or change) alarm group
				case 'add:alarmgroup' :
					this._showAddAlarm();
					break;
				
				
				// remove alarmgroup and change subscription
				case 'remove:alarmgroup' :
					this._showRemoveAlarm()
					break;
				
			}
			
		} );
		// If there is only one option (swap) available to the user, redirect to that replaceflow directly
		!isTechSupport && !hasAlarmGroup
		? this._showSwapSubscription()
		: this.showChildView( 'container', subscriptionReplaceChoiceForm );
		
	},
} );

export default SubscriptionContainer;